import SvgIcon from '..';

const ThumbsUp = (props) => {
  const svg = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8 9.30001V5.70002C13.8 4.20883 12.5912 3 11.1 3L7.5 11.1V21H17.958C18.8556 21.0102 19.6235 20.3575 19.758 19.47L21 11.37C21.0793 10.8479 20.9252 10.3173 20.5787 9.91876C20.2322 9.52026 19.7281 9.29401 19.2 9.30001H13.8Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 10.9998H5.097C4.04266 10.9812 3.14135 11.8545 3 12.8995V19.1995C3.14135 20.2445 4.04266 21.0181 5.097 20.9995H7.5V10.9998Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  return <SvgIcon component={svg} {...props} />;
};
const ThumbsDown = (props) => {
  const svg = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1911 14.7001V18.3001C10.1911 19.7913 11.3999 21.0001 12.8911 21.0001L16.4911 12.9001V3.00012H6.03311C5.13556 2.98997 4.36768 3.64265 4.2331 4.53012L2.9911 12.6301C2.91185 13.1523 3.06589 13.6829 3.41242 14.0814C3.75896 14.4799 4.26302 14.7061 4.7911 14.7001H10.1911Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M16.4912 3.00033H18.8942C19.9486 2.98168 20.8499 3.75534 20.9912 4.80033V11.1003C20.8499 12.1453 19.9486 13.019 18.8942 13.0003H16.4912V3.00033Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    );
  };
  return <SvgIcon component={svg} {...props} />;
};

export { ThumbsDown, ThumbsUp };
